<script>
import FooterItem from '@components/footer-item.vue'
import { authComputed } from '@state/helpers'

export default {
  components: { FooterItem },
  props: {
    sidebarExpanded: {
      type: Boolean,
    },
  },
  data() {
    return {
      footerRoutes: [
        {
          name: 'home',
          title: 'Home',
        },
        {
          name: 'apps',
          title: 'Apps',
        },
        {
          name: 'resources',
          title: 'Resources',
        },
        {
          name: 'education',
          title: 'Education',
          icon: 'Book',
        },
        {
          name: 'awards',
          title: 'Awards',
        },
        {
          name: 'network-connect',
          title: 'Network',
          icon: 'Connection',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
    routeSidebarItemName() {
      if (this.$route.meta?.sidebarItemName === 'Network Connect') {
        return 'Network'
      }

      return this.$route.meta?.sidebarItemName
    },

    getFooterRoutes() {
      let footerRoutes = this.footerRoutes
      if (process.env.APP_ENV === 'prod') {
        footerRoutes = footerRoutes.filter((route) => !route.devOnly)
      }

      if (!this.canManageNetworkConnect) {
        footerRoutes = footerRoutes.filter((route) => route.name !== 'network-connect')
      }

      if (!this.canAccessEducation) {
        footerRoutes = footerRoutes.filter((route) => route.name !== 'education')
      }

      return [...footerRoutes]
    },
  },
}
</script>

<template>
  <div :class="$style.footerContainer">
    <FooterItem
      v-for="footerRoute in getFooterRoutes"
      :key="footerRoute.title"
      :icon="footerRoute.icon || footerRoute.title"
      :route="footerRoute"
      :label="footerRoute.title"
      :active="footerRoute.title === routeSidebarItemName" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.footerContainer {
  @media (max-width: $lg-breakpoint) {
    position: fixed;
    bottom: 0;
    z-index: 1000;
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 88px;
    padding: 0 20px;
    background: $white;
    border-radius: 0 32px 0 0;
    box-shadow: 0 0 24px 0 rgba(196, 196, 196, 0.28);
  }

  display: none;
}
</style>
